import { dom } from './dom.js';
import { state } from './state.js';
import { SAMPLES } from './samples.js';
import { UI } from './ui.js';
import { Utils } from './utils.js';
import { Parser } from './parser.js';
import { TreeRenderer } from './tree-renderer.js';
import { THEMES, ThemeManager } from './themes.js';

export const Actions = {
  loadSample(sample) {
    dom.inputArea.value = SAMPLES[sample] || '';
    Parser.parse();
    UI.closeDropdowns();
  },

  setLayout(layout) {
    if (window.matchMedia('(max-width: 640px)').matches) {
      UI.closeDropdowns();
      return;
    }
    state.layout = layout;
    UI.updateLayoutControls();
    UI.resetPaneSize();
    UI.closeDropdowns();
  },

  toggleOption(option) {
    state[option] = !state[option];
    UI.updateOptionControls();
    if (state.lastParsed !== null) TreeRenderer.render(state.lastParsed);
    UI.closeDropdowns();
  },

  setTheme(themeKey) {
    if (!THEMES[themeKey]) return;
    state.theme = themeKey;
    ThemeManager.apply(themeKey);
    UI.updateThemeControls();
    UI.closeDropdowns();
  },

  async copyOutput() {
    if (state.lastParsed === null) return;

    try {
      await navigator.clipboard.writeText(JSON.stringify(state.lastParsed, null, 2));
      Utils.showToast('Copied!');
    } catch {
      Utils.showToast('Copy failed');
    }
  },

  clear() {
    dom.inputArea.value = '';
    dom.searchInput.value = '';
    dom.searchCount.textContent = '';
    state.lastParsed = null;
    UI.showError();
    Utils.setStatusBadge(dom.inputBadge, 'JSON');
    Utils.setStatusBadge(dom.outputBadge, '—');
    UI.renderEmptyState('Parse some JSON to see the tree here.');
  },
};
